import React from "react";
import { useHistory } from "react-router";
import Images from "../../assets/Images/0_ExportImages";
import { loginAPI } from "../../services/postAPIs";
import "./login-style.scss";
export default function LoginComponent() {
  const emailRegex = /([\w\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?/gm;
  const [credential, setCredential] = React.useState({
    username: "",
    password: "",
    projectId: 3
  });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const history = useHistory();

  const handleSubmit = async () => {
    let res;
    setLoading(true);
    try {
      res = await loginAPI(credential);
      if (res.data.success) {
        localStorage.setItem("userToken", res.data.data);
        localStorage.setItem("username", credential.username);
        history.push("/home/transaction");
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
    }
    setLoading(false);
  };

  return (
    <div className="login-main">
      <header>
        <nav>
          <div>
            <img src={Images.ethScan} />
          </div>
        </nav>
      </header>
      <section>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            loading ? console.log() : handleSubmit();
          }}
        >
          <div className="login-form-titles">
            <h2>
              Welcome <b>back</b>
            </h2>
            <p>Login to your account</p>
          </div>
          <div className="login-form-inputs">
            <p>Email</p>
            <input
              className={error ? "error" : ""}
              onChange={(e) =>
                setCredential({ ...credential, username: e.target.value })
              }
              // type="email"
              value={credential.username}
              placeholder="Email"
              // required
            />
          </div>
          <div className="login-form-inputs">
            <p>Password</p>
            <input
              className={error ? "error" : ""}
              onChange={(e) =>
                setCredential({ ...credential, password: e.target.value })
              }
              type="password"
              value={credential.password}
              placeholder="Password"
              minLength="8"
              required
            />
          </div>
          <div className="login-form-bottom">
            <div>
              <p>
                Don't have an account?{" "}
                <span onClick={() => history.push("/register")}>
                  Click To Sign Up
                </span>
              </p>
              <p>
                Or explore{" "}
                <span onClick={() => history.push("/home")}>
                  Blockchain Machine
                </span>
              </p>
            </div>
            <button
              // onClick={() => (loading ? console.log() : handleSubmit())}
              disabled={
                credential.password.length < 3 
                // ||
                // !emailRegex.test(credential.username)
              }
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </div>
        </form>
      </section>
      <footer></footer>
    </div>
  );
}
